import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import useApiHandler from 'hooks/useApiHandler';

import { updateSetupGuideStatusAction } from 'redux/actions/apiCall';
import { useGetSetupGuideStatus } from 'redux/slices/globalApi';

/**
 * Shared "Request Sandbox" trigger. Hits the setup-guide API with `sandboxRequested=1`
 * and pushes the refreshed status (with `sentSandboxRequest: true`) into Redux so the
 * requesting UI can disable itself. Used by the setup guide and the navbar button.
 */
export default function useRequestSandbox() {
    const dispatch = useDispatch();
    const [setupGuideStatus] = useGetSetupGuideStatus();
    const apiHandler = useApiHandler();

    return useCallback(async () => {
        const response = await apiHandler(setupGuideStatus, { sandboxRequested: 1 });
        if (response?.data) dispatch(updateSetupGuideStatusAction(response.data));
        return response;
    }, [apiHandler, setupGuideStatus, dispatch]);
}
